export interface draftDto {
	id?: number;
	xmlBase64?: string;
}

export interface NCASignDto {
	module: string;
	method: string;
	args: {
		allowedStorages: string[];
		format: "xml" | "cms";
		data: string;
		signingParams: {
			decode: boolean;
			encapsulate: boolean;
			digested: boolean;
			tsaProfile: any | null;
		},
		signerParams: {
			extKeyUsageOids: string[];
			iin: string;
			bin: string;
			serialNumber: string;
			chain: string[];
		},
		locale: "ru" | "kk";
	};
}

export interface NCASignResponseDto {
	result?: {
		version?: string;
	};
	body?: {
		result?: string[];
	},
	status?: boolean;
}

export const nCASign: NCASignDto = {
    module: "kz.gov.pki.knca.basics",
    method: "sign",
    args: {
        allowedStorages: [
            "AKKaztokenStore",
            "AKKZIDCardStore",
            "AKEToken72KStore",
            "AKEToken5110Store",
            "AKJaCartaStore",
            "PKCS12",
            "JKS",
            "AKAKEYStore"
        ],
        format: "cms",
        data: "AKEToken5110Store",
        signingParams: {
            decode: true,
            encapsulate: false,
            digested: false,
            tsaProfile: null
        },
        signerParams: {
            extKeyUsageOids: [
                "1.3.6.1.5.5.7.3.4"
            ],
            iin: "",
            bin: "",
            serialNumber: "",
            chain: []
        },
        locale: "ru"
    }
}
